// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__8KmNV","title":"InfoRow_title__2_L-Z"};